const Vue = require('vue');
const EventBus = new Vue();
export default EventBus;
